var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeOutlinesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09885 1.87792C9.24907 1.61503 9.54262 1.46826 9.843 1.50581L10.1833 1.54835C12.0337 1.77964 13.227 3.62515 12.6786 5.40745L12.2655 6.74999H12.8041C14.7823 6.74999 16.219 8.63092 15.6985 10.5394L14.6758 14.2894C14.3198 15.5945 13.1343 16.5 11.7814 16.5H4.5C3.25736 16.5 2.25 15.4926 2.25 14.25V9C2.25 7.75732 3.25736 6.74999 4.5 6.74999H6C6.19464 6.74999 6.37436 6.6457 6.47093 6.47671L9.09885 1.87792ZM7.5 15H11.7814C12.4579 15 13.0506 14.5473 13.2286 13.8946L14.2513 10.1446C14.5116 9.19042 13.7932 8.25 12.8041 8.25H11.25C11.012 8.25 10.7881 8.13705 10.6467 7.94557C10.5053 7.7541 10.4632 7.5069 10.5331 7.27943L11.2449 4.96631C11.5038 4.12488 10.9863 3.25527 10.1489 3.06351L7.7733 7.22092C7.53915 7.63065 7.17518 7.93942 6.75 8.10735V14.25C6.75 14.6642 7.08579 15 7.5 15Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeOutlinesIcon);
export default __webpack_public_path__ + "static/media/LikeOutlinesIcon.29d51c433064a8e9453e2433bdefbee3.svg";
export { ForwardRef as ReactComponent };